module.exports = __webpack_public_path__ + "static/media/Tentacle_Reinforcement_Opening.e06efae5.mp3";